import type { IMenuItemSDKAction } from '@wix/editor-elements-corvid-utils';
import type {
  IMenuItemProps,
  MenuAnimationNameType,
  MenuOrientationType,
  MenuVerticalDropdownDisplayType,
} from '../../../Menu.types';
import { MenuOrientation, VerticalDropdownDisplay } from '../../../constants';

export const createSDKAction = (
  item: IMenuItemProps['item'],
  selected: boolean,
  sdkAction?: IMenuItemSDKAction,
) =>
  sdkAction &&
  ((e: React.MouseEvent) => {
    sdkAction?.(e, {
      ...item,
      selected,
    });
  });

export const getMenuOrientation = (itemRef: React.RefObject<HTMLLIElement>) => {
  if (!itemRef?.current) {
    return;
  }

  const orientation = getComputedStyle(itemRef.current).getPropertyValue(
    '--orientation',
  ) as MenuOrientationType;

  return orientation;
};

export const getVerticalDropdownDispaly = (
  itemRef: React.RefObject<HTMLLIElement>,
) => {
  if (!itemRef?.current) {
    return;
  }

  const verticalDropdownDisplay = getComputedStyle(
    itemRef.current,
  ).getPropertyValue(
    '--vertical-dropdown-display',
  ) as MenuVerticalDropdownDisplayType;

  return verticalDropdownDisplay;
};

export const getIsAlwaysOpen = (itemRef: React.RefObject<HTMLLIElement>) => {
  const isVertical = getMenuOrientation(itemRef) === MenuOrientation.Vertical;
  const verticalDropdownDisplay = getVerticalDropdownDispaly(itemRef);
  const isAlwaysOpen =
    isVertical &&
    verticalDropdownDisplay === VerticalDropdownDisplay.AlwaysOpen;

  return isAlwaysOpen;
};

type CreateEventListenersOptions = {
  showDropdown: () => void;
  hideDropdown: () => void;
  itemRef: React.RefObject<HTMLLIElement>;
  getMenuItemAnimationName: () => MenuAnimationNameType;
  initEnterAnimation: (animationName: MenuAnimationNameType) => void;
  initExitAnimation: (
    animationName: MenuAnimationNameType,
    onAnimationDone?: () => void,
  ) => void;
  isOpen: boolean;
  hasLink: boolean;
};

export const createEventListeners = ({
  showDropdown,
  hideDropdown,
  itemRef,
  getMenuItemAnimationName,
  initEnterAnimation,
  initExitAnimation,
  isOpen,
  hasLink,
}: CreateEventListenersOptions) => {
  return {
    onMouseEnter: () => {
      const isHorizontal =
        getMenuOrientation(itemRef) === MenuOrientation.Horizontal;
      const isVertical = !isHorizontal;
      const isAlwaysOpen = getIsAlwaysOpen(itemRef);
      const isVerticalExpanded = isVertical && isOpen;

      if (!hasLink && (isAlwaysOpen || isVerticalExpanded)) {
        return;
      }

      const animationName = getMenuItemAnimationName();

      if (isHorizontal) {
        showDropdown();
      }
      initEnterAnimation(animationName);
    },
    onMouseLeave: () => {
      const isHorizontal =
        getMenuOrientation(itemRef) === MenuOrientation.Horizontal;
      const isVertical = !isHorizontal;
      const isAlwaysOpen = getIsAlwaysOpen(itemRef);
      const isVerticalExpanded = isVertical && isOpen;

      if (!hasLink && (isAlwaysOpen || isVerticalExpanded)) {
        return;
      }

      const animationName = getMenuItemAnimationName();

      if (isHorizontal) {
        hideDropdown();
      }
      initExitAnimation(animationName);
    },
  };
};
